import React from 'react'
import PropTypes from 'prop-types'
import {
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    Flex,
    Img,
    Text,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {MinusIcon, PlusIcon} from '../../../icons'
import SanitizedHtml from '../../../html-sanitizer'

const ACCORDION_MOTION_PROPS = {
    transition: {
        enter: {duration: 0.28, ease: 'easeInOut'},
        exit: {duration: 0.28, ease: 'easeInOut'},
    },
}

const CollapsibleSectionItem = ({item, isExpanded}) => {
    const styles = useMultiStyleConfig('CollapsibleSection', {})

    if (!item) return null

    return (
        <AccordionItem
            {...styles.benefitItem}
            {...(!isExpanded ? styles.benefitItemClosed : {})}
            data-testid="collapsible-section-item"
        >
            {({isExpanded}) => (
                <>
                    <AccordionButton {...styles.benefitAccordionButtonContainer}>
                        <Flex {...styles.benefitIconAndTitleContainer}>
                            {item?.icon?.url && (
                                <Img
                                    src={item.icon.url}
                                    alt=""
                                    aria-hidden="true"
                                    {...styles.benefitIcon}
                                />
                            )}
                            <Text as="span" {...styles.benefitTitle}>
                                {item?.title}
                            </Text>
                        </Flex>
                        <Box
                            {...styles.iconBox}
                            transform={isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}
                            aria-hidden="true"
                        >
                            {isExpanded ? (
                                <MinusIcon {...styles.benefitAccordionButton} />
                            ) : (
                                <PlusIcon {...styles.benefitAccordionButton} />
                            )}
                        </Box>
                    </AccordionButton>
                    <AccordionPanel {...styles.benefitPanel} motionProps={ACCORDION_MOTION_PROPS}>
                        {item?.subtitle && (
                            <SanitizedHtml
                                as={Text}
                                html={item.subtitle}
                                {...styles.benefitDescription}
                            />
                        )}
                    </AccordionPanel>
                </>
            )}
        </AccordionItem>
    )
}

CollapsibleSectionItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        icon: PropTypes.shape({url: PropTypes.string}),
    }),
    isExpanded: PropTypes.bool,
}

export default CollapsibleSectionItem
